import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TabBar, SkeletonHero, SkeletonCard, SectionError } from '../components/intel/ui';
import ClubHeader from '../components/intel/ClubHeader';
import ClubOverview from '../components/intel/ClubOverview';
import ClubSquad from '../components/intel/ClubSquad';
import ClubStatistics from '../components/intel/ClubStatistics';
import ClubFixtures from '../components/intel/ClubFixtures';
import StandingsTable from '../components/intel/StandingsTable';
import { buildSquadNameMap } from '../lib/clubHelpers';

const TABS = ['Overview', 'Squad', 'Statistics', 'Fixtures', 'Standings'];
const EP = (id) => `https://stats.interaios.com/api/v1/teams-sportsmonk/get-team/${id}`;

export default function ClubProfile() {
  const { clubId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tab, setTab] = useState('Overview');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true); setError(null);
      try {
        const res = await fetch(EP(clubId));
        if (!res.ok) throw new Error('Club data unavailable');
        const json = await res.json();
        if (!json?.data?.overview) throw new Error('Club data unavailable');
        if (!cancelled) setData(json.data);
      } catch (e) { if (!cancelled) setError(e.message); }
      finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, [clubId]);

  const nameMap = data ? buildSquadNameMap(data) : {};
  return (
    <div className="intel">
      {loading && (<><SkeletonHero />{[1, 2, 3].map((i) => <SkeletonCard key={i} />)}</>)}
      {error && <SectionError message={error} onRetry={() => navigate(0)} />}
      {data && !loading && (
        <>
          <ClubHeader data={data} backPath="/club-intelligence" />
          <div className="i-card p-0 mb-4">
            <TabBar tabs={TABS} active={tab} onChange={setTab} />
            <div className="p-4">
              {tab === 'Overview' && <ClubOverview data={data} nameMap={nameMap} />}
              {tab === 'Squad' && <ClubSquad data={data} />}
              {tab === 'Statistics' && <ClubStatistics data={data} nameMap={nameMap} />}
              {tab === 'Fixtures' && <ClubFixtures data={data} />}
              {tab === 'Standings' && (
                data?.standings?.length
                  ? <StandingsTable rows={data.standings} highlightParticipantId={data.overview?.id} />
                  : <p className="i-dim text-sm">No standings available.</p>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
